import React, { useMemo } from 'react';
import { AutoFields, EditView } from '@builtbypixel/nucleus';
import { Button, Box } from '@builtbypixel/plasma';
import { useFormContext } from 'react-hook-form';
import setup from './setup';

const ProfileButton = () => {
    const { watch } = useFormContext();
    const profile = watch('slug');

    return (
        <Box w='100%' p='20px'>
            <Button
                onClick={() =>
                    (window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/mosques/${profile}`)
                }
                variantColor='primary'
            >
                View Mosque Profile
            </Button>
        </Box>
    );
};

const EditForm = () => {
    const fields = useMemo(
        () => [
            {
                group: 'Mosque Details',
                fields: [
                    {
                        name: 'name',
                        component: 'text',
                        placeholder: 'Mosque Name',
                        label: 'Mosque Name',
                        isRequired: true,
                        rules: { required: true },
                    },
                    {
                        name: 'mosque_email',
                        component: 'text',
                        type: 'email',
                        placeholder: 'Mosque Email',
                        label: 'Mosque Email',
                        isRequired: true,
                        rules: { required: true, email: true },
                    },
                    {
                        name: 'phone_number',
                        component: 'text',
                        type: 'number',
                        placeholder: 'Phone Number',
                        label: 'Phone Number',
                    },
                    {
                        name: 'master_mosque',
                        component: 'switch',
                        placeholder: 'Is Master Mosque?',
                        label: 'Is Master Mosque?',
                        size: 'lg',
                    },
                ],
            },
            {
                group: 'Mosque Location',
                fields: [
                    {
                        name: 'lat',
                        component: 'text',
                        placeholder: 'Latitude',
                        label: 'Latitude',
                        isRequired: true,
                        rules: { required: true },
                    },
                    {
                        name: 'lng',
                        component: 'text',

                        placeholder: 'Longitude',
                        label: 'Longitude',
                        isRequired: true,
                        rules: { required: true, email: true },
                    },
                    {
                        name: 'address',
                        component: 'textarea',

                        placeholder: 'Address',
                        label: 'Address',
                    },
                ],
            },
        ],
        []
    );
    return (
        <EditView setup={setup}>
            <ProfileButton />
            <AutoFields fields={fields} />
        </EditView>
    );
};

export default EditForm;
